import { render } from "./SwdInfoBtn.vue?vue&type=template&id=1185a51b&scoped=true"
import script from "./SwdInfoBtn.vue?vue&type=script&lang=js"
export * from "./SwdInfoBtn.vue?vue&type=script&lang=js"

import "./SwdInfoBtn.vue?vue&type=style&index=0&id=1185a51b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1185a51b"]])

export default __exports__